import { createSlice } from '@reduxjs/toolkit'
import reducers from 'store/features/projectData/reducers'
import { getInitialState } from 'store/features/projectData/initialState'

const projectDataSlice = createSlice({
  name: 'projectData',
  initialState: getInitialState(),
  reducers
})

export default projectDataSlice
